module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-2-75.6ed57559.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-2-75.png
// module id = 2555
// module chunks = 11